<template>
  <div class="wrapper">
      <div class="tab-dados-basicos">
          <div class="form centro">      
              <form @submit.prevent="enviarForm">
                  <div class="caixa-form item">
                      <div class="flexbox-1"> 
                          <div class="item">
                              <!-- <label><b>Mensagem:</b></label>
                              <textarea placeholder="Adicione seu comentário" v-model="comentarioForm.mensagem" rows="5"></textarea> -->
                              <label><b>Mensagem:</b></label>
                                <textarea
                                    v-model="comentarioForm.mensagem"
                                    class="textarea"
                                    placeholder="Adicione seu comentário"
                                    rows="5">
                                </textarea>
                          </div>
                      </div>
                      <div class="bt-salvar">
                          <button id="botao-salvar" title="Criar/Atualizar" type="submit">
                              <img id="spinner-loading" class="spinner-loading"
                                  src="../../assets/imagens/loadingSpinner.gif" alt="Spinner de carregamento">
                              <p id="conteudo-botao">{{ comentarioForm.id ? "Atualizar" : "Criar" }}</p>
                          </button>
                      </div>
                  </div>
              </form>
          </div>
      </div>
  </div>
</template>

<script lang="js">
  import ComentarioApi from "../../services/ComentarioApi";

  export default {
      name: "comentarioForm",
      props: {
            comentario: {
                type: Object,
                default: () => ({}),
            },
            ocorrencia_id: {
                type: Number,
                required: false,
            },
      },
      data() {
    return {
        comentarioForm: this.comentario
            ? {
                id: this.comentario.id,
                mensagem: this.comentario.mensagem,
                ocorrencia_id: this.comentario?.ocorrencia_id || this.ocorrencia_id || null,
            }
            : {
                id: null,
                mensagem: null,
                ocorrencia_id: this.ocorrencia_id || 0,
            },
            msgErros: {
            mensagem: '',
            ocorrencia_id: '',
            default: '',
        },
    };
},

      components: {

      },
      created() {
          this.ComentarioApi = new ComentarioApi();
      },
      methods: {
         
          fecharErro() {
              this.erro = false;
          },
          
          mudarBotaoSalvar(textoBotao) {
              let botaoSalvar = document.getElementById("botao-salvar");
              let conteudoBotao = document.getElementById("conteudo-botao");
              let spinnerLoading = document.getElementById("spinner-loading");

              let novoTextoConteudoBotao = "Carregando"

              //mudar para o carregando
              botaoSalvar.disabled = true;
              botaoSalvar.style.backgroundColor = "gray"
              conteudoBotao.innerHTML = novoTextoConteudoBotao;
              conteudoBotao.style.display = "inline-block"
              spinnerLoading.style.visibility = "visible"
              spinnerLoading.style.position = "relative"

              if (this.erro == true) {
                  //mudar para o padrão (da aba dados básicos)
                  botaoSalvar.disabled = false;
                  botaoSalvar.style.backgroundColor = "#005516"
                  conteudoBotao.innerHTML = textoBotao;
                  spinnerLoading.style.visibility = "hidden"
                  spinnerLoading.style.position = "absolute"
              }
          },
          async enviarForm() {
                    let conteudoBotao = document.getElementById("conteudo-botao");
                    const textoConteudoBotao = conteudoBotao.innerHTML;
                    
                    let flag = this.validarForm(this.comentarioForm);

                    if (flag == 1) {
                        this.erro = true;
                        window.scrollTo({ top: 0, behavior: 'smooth' });
                        return false;
                    }

                    try {
                        this.carregando = true;
                        this.erro = false;
                        this.mudarBotaoSalvar(textoConteudoBotao);

                        if (this.ComentarioApi.cancelTokens.setComentario) {
                            this.ComentarioApi.cancelTokens.setComentario.cancel();
                        }

                        const data = await this.ComentarioApi.setComentario(this.comentarioForm);

                        // Emitir o evento para o pai atualizar a lista e manter na mesma tela
                        this.$emit("comentario-criado", data);

                        // Resetar o formulário
                        this.comentarioForm.mensagem = '';

                        // Resetar visual do botão
                        this.carregando = false;
                        this.mudarBotaoSalvar(textoConteudoBotao);
                    } catch (err) {
                        if (this.ComentarioApi.isCancel(err)) {
                            return;
                        }
                        console.log(err);
                        this.carregando = false;
                        this.erro = true;
                        this.mudarBotaoSalvar(textoConteudoBotao);

                        const { response } = err;
                        if (response && response.data) {
                            this.msgErros = response.data;
                        } else {
                            this.msgErros =
                                "Houve um erro ao salvar o registro. Por favor tente novamente.";
                        }
                    }
                },

          
          validarForm(comentarioForm) {
              let flag = 0;

              //Resetar as mensagens de erro
              this.msgErros.mensagem = ''
              this.msgErros.ocorrencia_id = ''
              this.msgErros.default = ''

              //Titulo não pode estar em branco
              if (comentarioForm.mensagem == null || comentarioForm.mensagem == '') {
                  this.msgErros.mensagem = "Mensagem não pode ficar em branco.";
                  flag = 1;
              }
               // Verificar se ocorrencia_id é válido
              if (comentarioForm.ocorrencia_id == null || comentarioForm.ocorrencia_id == 0) {
                  this.msgErros.ocorrencia_id = "Ocorrência deve ser válida e não pode ser zero.";
                  flag = 1;
            }

              return flag;
          },
          possuiAsterisco(texto) {
              var texto_final = "* " + texto
              return texto_final
          },
      },
  };
</script>

<style lang="scss">
</style>
